export default [
    {
        path: "/admin/users/barcode",
        component: () => import("../Components/Barcode.vue"),
        name: "admin.user.barcode",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/admin/user",
        component: () => import("../Components/List.vue"),
        name: "admin.user",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/users",
        component: () => import("../Components/BasicList.vue"),
        name: "admin.users",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/admin/basic-user/create",
        component: () => import("../Components/BasicUserCreate.vue"),
        name: "admin.basic-user.create",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/admin/users/:id/edit",
        component: () => import("../Components/Edit.vue"),
        name: "admin.user.edit",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/admin/users/other-units",
        component: () => import("../Components/OtherUnitUsers.vue"),
        name: "admin.user.other",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/admin/users/deleted",
        component: () => import("../Components/Deleted.vue"),
        name: "admin.user.deleted",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/admin/users/lrc",
        component: () => import("../Components/LRC.vue"),
        name: "admin.user.lrc",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/admin/users/status",
        component: () => import("../Components/StatusUpdate.vue"),
        name: "admin.user.status",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/admin/users/create",
        component: () => import("../Components/Create.vue"),
        name: "admin.user.create",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/admin/users/bulk-create",
        component: () => import("../Components/CreateBulk.vue"),
        name: "admin.user.bulk.create",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/admin/users/import",
        component: () => import("../Components/Import.vue"),
        name: "admin-user-import",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/admin/users/wpn-assign",
        component: () => import("../Components/WpnAssign/Item.vue"),
        name: "admin.user.wpn.assign",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/admin/users/wpn-assign/:id/edit",
        component: () => import("../Components/WpnAssign/Edit.vue"),
        name: "admin.user.wpn.assign.edit",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/admin/user/:id/calendar",
        component: () => import("../Components/Calendar/Index.vue"),
        name: "admin.user.calendar",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/admin/user/report/pending-password-reset",
        component: () => import("../Components/ResetPassword.vue"),
        name: "admin-pending-password-reset",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/admin/user/js-tree",
        component: () => import("../Components/JsTree.vue"),
        name: "admin-user-js-tree",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/admin/user/change-appt",
        component: () => import("../Components/ChangeAppt.vue"),
        name: "admin-change-appt",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/admin/online-users/list",
        component: () => import("../Components/OnlineUsers.vue"),
        name: "admin-online-users",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/admin/users/id-card",
        component: () => import("../Components/UserIdCard.vue"),
        name: "admin-users-id-card",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/admin/users/photo-card",
        component: () => import("../Components/UserPhotoCard.vue"),
        name: "admin-users-photo-card",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/admin/users/photo-album",
        component: () => import("../Components/UserPhotoAlbum.vue"),
        name: "admin-users-photo-album",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/admin/users/list",
        component: () => import("../Components/List.vue"),
        name: "admin-user-list",
        meta: {
            requiresAuth: true,
        },
    },
];
